/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Channel API
 * Апи для управления каналами коммуникации
 * OpenAPI spec version: 1.0.0
 */
import { faker } from '@faker-js/faker';

import { HttpResponse, delay, http } from 'msw';
import type { RequestHandlerOptions } from 'msw';

import { createChannelManagementInstance } from '../../api-instance';
import type { BodyType } from '../../api-instance';
export interface ChannelListPagination {
  data?: ChannelList[];
  pagination?: Pagination;
}

export interface ChannelList {
  /** ID канала */
  id: string;
  /** ID владельца канала */
  owner_id: string;
  protocol: Protocol;
  status: ChannelStatus;
  /** Канал активен */
  is_active: boolean;
  /** Название канала */
  name?: string;
  /** Аватар/логотип канала */
  avatar_url?: string;
  /** Номер телефона */
  phone_number: string;
  /** id компании, которой принадлежит канал */
  company_id?: string;
}

export interface ChannelDetails {
  /** ID канала */
  id: string;
  /** ID владельца канала */
  owner_id: string;
  protocol: Protocol;
  status: ChannelStatus;
  /** Канал активен */
  is_active: boolean;
  /** Ссылка для QR кода */
  qr_url?: string;
  /** Время жизни QR кода */
  qr_expires?: string;
  /** Название канала */
  name?: string;
  /** Аватар/логотип канала */
  avatar_url?: string;
  /** Номер телефона */
  phone_number: string;
  /** id компании, которой принадлежит канал */
  company_id?: string;
}

export interface ChannelQrResponse {
  /** ID канала */
  id?: string;
  /** Ссылка для QR кода */
  qr_url: string;
  /** Время жизни QR кода */
  qr_expires: string;
  status: ChannelStatus;
}

export interface ChannelTgBotCreate {
  /** Токен бота */
  token?: string;
}

export interface TgPassword {
  /** Тг пароль */
  password: string;
}

/**
 * Что сделать с чатами старого номера
 */
export type UpdateNumberBodyOldChats =
  (typeof UpdateNumberBodyOldChats)[keyof typeof UpdateNumberBodyOldChats];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateNumberBodyOldChats = {
  keep: 'keep',
  delete: 'delete',
} as const;

export interface UpdateNumberBody {
  /** Что сделать с чатами старого номера */
  old_chats?: UpdateNumberBodyOldChats;
}

export interface ChannelUpdate {
  /** Активность канала */
  is_active?: boolean;
  /** Название канала */
  name?: string;
}

/**
 * Протокол
 */
export type Protocol = (typeof Protocol)[keyof typeof Protocol];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Protocol = {
  telegram_personal: 'telegram_personal',
  telegram_bot: 'telegram_bot',
  whatsapp_gray: 'whatsapp_gray',
  infobip: 'infobip',
  max: 'max',
  vk: 'vk',
} as const;

/**
 * Статус канала коммуникации
 */
export type ChannelStatus = (typeof ChannelStatus)[keyof typeof ChannelStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChannelStatus = {
  unauthorized: 'unauthorized',
  pending_payment: 'pending_payment',
  qr_in_progress: 'qr_in_progress',
  sms_sent: 'sms_sent',
  password_required: 'password_required',
  authorized: 'authorized',
  contacts_synced: 'contacts_synced',
  chats_synced: 'chats_synced',
  ready: 'ready',
  required_scan_qr: 'required_scan_qr',
} as const;

export interface Pagination {
  total: number;
  page: number;
  limit: number;
}

export interface ProblemDetails {
  /** Тип ошибки */
  type: string;
  /** Название ошибки */
  title: string;
  /** Подробное описание ошибки */
  detail: string;
  /** Код состояния HTTP */
  status: number;
  /** Бизнес код ошибки */
  code?: string;
}

export type Log = RequiredID & LogBase;

/**
 * id of the object which is required
 */
export interface RequiredID {
  id: string;
}

export interface LogBase {
  /** TimeUUID of the owner channel */
  channel_id: string;
  /** severity level */
  severity: string;
  /** Timestamp of the log */
  event_time: string;
  /** Log message */
  content: string;
  /** log type */
  type: string;
}

export interface InitSmsQuery {
  /** Номер телефона */
  phone: string;
}

export interface VerifySmsQuery {
  /** Номер телефона */
  phone: string;
  /** СМС код подтверждения */
  code: string;
}

export interface ChannelCreate {
  protocol: Protocol;
}

export type GetChannelsParams = {
  /**
   * Номер страницы
   */
  page?: number;
  /**
   * Кол-во элементов на странице
   */
  limit?: number;
};

export type GetChannelLogsByChannelIdParams = {
  /**
   * Timestamp to start from (exclusive, in ISO 8601 format)
   */
  from?: string;
  /**
   * time of the last record
   */
  to?: string;
  /**
   * filter by severity field
   */
  severity?: string;
  /**
   * Number of logs to return
   */
  count?: number;
};

export type UpdateTgBotChannelParams = {
  /**
   * токен бота
   */
  token: string;
};

export type UpdateMaxBotChannelParams = {
  /**
   * токен бота MAX
   */
  token: string;
};

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Создание нового TG Personal канала
 */
export const createTgPersonalChannel = (
  options?: SecondParameter<
    typeof createChannelManagementInstance<ChannelDetails>
  >
) => {
  return createChannelManagementInstance<ChannelDetails>(
    { url: `/api/v1/channels/tg_personal`, method: 'POST' },
    options
  );
};

/**
 * @summary Создание нового TG Bot канала
 */
export const createTgBotChannel = (
  channelTgBotCreate: BodyType<ChannelTgBotCreate>,
  options?: SecondParameter<
    typeof createChannelManagementInstance<ChannelDetails>
  >
) => {
  return createChannelManagementInstance<ChannelDetails>(
    {
      url: `/api/v1/channels/tg_bot`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: channelTgBotCreate,
    },
    options
  );
};

/**
 * @summary Создание нового whatsapp gray канала
 */
export const createWhatsappGrayChannel = (
  options?: SecondParameter<
    typeof createChannelManagementInstance<ChannelDetails>
  >
) => {
  return createChannelManagementInstance<ChannelDetails>(
    { url: `/api/v1/channels/whatsapp`, method: 'POST' },
    options
  );
};

/**
 * @summary Создаёт шаблон канала указанного типа
 */
export const initiateCreateChannel = (
  channelType: 'telegram_personal' | 'telegram_bot' | 'whatsapp_gray' | 'max' | 'vk',
  options?: SecondParameter<
    typeof createChannelManagementInstance<ChannelDetails>
  >
) => {
  return createChannelManagementInstance<ChannelDetails>(
    { url: `/api/v1/channel/create/${channelType}`, method: 'POST' },
    options
  );
};

/**
 * @summary Список каналов коммуникации
 */
export const getChannels = (
  params?: GetChannelsParams,
  options?: SecondParameter<
    typeof createChannelManagementInstance<ChannelListPagination>
  >
) => {
  return createChannelManagementInstance<ChannelListPagination>(
    { url: `/api/v1/channels`, method: 'GET', params },
    options
  );
};

/**
 * @summary Создание нового канала
 */
export const createChannel = (
  channelCreate: BodyType<ChannelCreate>,
  options?: SecondParameter<
    typeof createChannelManagementInstance<ChannelDetails>
  >
) => {
  return createChannelManagementInstance<ChannelDetails>(
    {
      url: `/api/v1/channels`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: channelCreate,
    },
    options
  );
};

/**
 * @summary Получение канала коммуникации по channel_id
 */
export const getChannelById = (
  channelId: string,
  options?: SecondParameter<
    typeof createChannelManagementInstance<ChannelDetails>
  >
) => {
  return createChannelManagementInstance<ChannelDetails>(
    { url: `/api/v1/channels/${channelId}`, method: 'GET' },
    options
  );
};

/**
 * @summary Обновление канала
 */
export const updateChannelById = (
  channelId: string,
  channelUpdate: BodyType<ChannelUpdate>,
  options?: SecondParameter<
    typeof createChannelManagementInstance<ChannelDetails>
  >
) => {
  return createChannelManagementInstance<ChannelDetails>(
    {
      url: `/api/v1/channels/${channelId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: channelUpdate,
    },
    options
  );
};

/**
 * @summary Удаление канала комуникации
 */
export const deleteChannelById = (
  channelId: string,
  options?: SecondParameter<typeof createChannelManagementInstance<void>>
) => {
  return createChannelManagementInstance<void>(
    { url: `/api/v1/channels/${channelId}`, method: 'DELETE' },
    options
  );
};

/**
 * @summary Получение логов канала коммуникации по channel_id
 */
export const getChannelLogsByChannelId = (
  channelId: string,
  params?: GetChannelLogsByChannelIdParams,
  options?: SecondParameter<typeof createChannelManagementInstance<Log[]>>
) => {
  return createChannelManagementInstance<Log[]>(
    { url: `/api/v1/channels/${channelId}/logs`, method: 'GET', params },
    options
  );
};

/**
 * @summary Повторная qr аутентификация TG Personal/Whatsapp канала
 */
export const qrLoginChannel = (
  channelId: string,
  options?: SecondParameter<
    typeof createChannelManagementInstance<ChannelDetails>
  >
) => {
  return createChannelManagementInstance<ChannelDetails>(
    { url: `/api/v1/channels/${channelId}/qr_login`, method: 'POST' },
    options
  );
};

/**
 * @summary Отправка пароля для авторизации
 */
export const sendTgPersonalPassword = (
  channelId: string,
  tgPassword: BodyType<TgPassword>,
  options?: SecondParameter<typeof createChannelManagementInstance<void>>
) => {
  return createChannelManagementInstance<void>(
    {
      url: `/api/v1/channels/${channelId}/tg_personal/password`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: tgPassword,
    },
    options
  );
};

/**
 * @summary Отправка пароля для авторизации по облачному паролю
 */
export const privateSendTgPersonalPassword = (
  channelId: string,
  tgPassword: BodyType<TgPassword>,
  options?: SecondParameter<typeof createChannelManagementInstance<void>>
) => {
  return createChannelManagementInstance<void>(
    {
      url: `/api/v1/private/channels/${channelId}/tg_personal/password`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: tgPassword,
    },
    options
  );
};

/**
 * @summary Обновление TG Bot канала
 */
export const updateTgBotChannel = (
  channelId: string,
  params: UpdateTgBotChannelParams,
  options?: SecondParameter<
    typeof createChannelManagementInstance<ChannelDetails>
  >
) => {
  return createChannelManagementInstance<ChannelDetails>(
    {
      url: `/api/v1/channels/tg_bot/${channelId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: params,
    },
    options
  );
};

/**
 * @summary Обновление MAX Bot канала
 */
export const updateMaxBotChannel = (
  channelId: string,
  params: UpdateMaxBotChannelParams,
  options?: SecondParameter<
    typeof createChannelManagementInstance<ChannelDetails>
  >
) => {
  return createChannelManagementInstance<ChannelDetails>(
    {
      url: `/api/v1/channels/max_bot/${channelId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: params,
    },
    options
  );
};

/**
 * Сброс авторизации текущего канала перед подключением нового номера
 * @summary Обновление номера телефона канала
 */
export const updateNumber = (
  channelId: string,
  updateNumberBody?: BodyType<UpdateNumberBody>,
  options?: SecondParameter<
    typeof createChannelManagementInstance<ChannelDetails>
  >
) => {
  return createChannelManagementInstance<ChannelDetails>(
    {
      url: `/api/v1/channels/${channelId}/update_number`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: updateNumberBody,
    },
    options
  );
};

/**
 * @summary Запрос отправки смс по переданному номеру телефона
 */
export const initSMS = (
  channelId: string,
  initSmsQuery: BodyType<InitSmsQuery>,
  options?: SecondParameter<typeof createChannelManagementInstance<void>>
) => {
  return createChannelManagementInstance<void>(
    {
      url: `/api/v1/channels/${channelId}/init-sms`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: initSmsQuery,
    },
    options
  );
};

/**
 * @summary Верификация отправленного смс кода на телефон
 */
export const verifySMS = (
  channelId: string,
  verifySmsQuery: BodyType<VerifySmsQuery>,
  options?: SecondParameter<typeof createChannelManagementInstance<void>>
) => {
  return createChannelManagementInstance<void>(
    {
      url: `/api/v1/channels/${channelId}/verify-sms`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: verifySmsQuery,
    },
    options
  );
};

export type CreateTgPersonalChannelResult = NonNullable<
  Awaited<ReturnType<typeof createTgPersonalChannel>>
>;
export type CreateTgBotChannelResult = NonNullable<
  Awaited<ReturnType<typeof createTgBotChannel>>
>;
export type CreateWhatsappGrayChannelResult = NonNullable<
  Awaited<ReturnType<typeof createWhatsappGrayChannel>>
>;
export type InitiateCreateChannelResult = NonNullable<
  Awaited<ReturnType<typeof initiateCreateChannel>>
>;
export type GetChannelsResult = NonNullable<
  Awaited<ReturnType<typeof getChannels>>
>;
export type CreateChannelResult = NonNullable<
  Awaited<ReturnType<typeof createChannel>>
>;
export type GetChannelByIdResult = NonNullable<
  Awaited<ReturnType<typeof getChannelById>>
>;
export type UpdateChannelByIdResult = NonNullable<
  Awaited<ReturnType<typeof updateChannelById>>
>;
export type DeleteChannelByIdResult = NonNullable<
  Awaited<ReturnType<typeof deleteChannelById>>
>;
export type GetChannelLogsByChannelIdResult = NonNullable<
  Awaited<ReturnType<typeof getChannelLogsByChannelId>>
>;
export type QrLoginChannelResult = NonNullable<
  Awaited<ReturnType<typeof qrLoginChannel>>
>;
export type SendTgPersonalPasswordResult = NonNullable<
  Awaited<ReturnType<typeof sendTgPersonalPassword>>
>;
export type PrivateSendTgPersonalPasswordResult = NonNullable<
  Awaited<ReturnType<typeof privateSendTgPersonalPassword>>
>;
export type UpdateTgBotChannelResult = NonNullable<
  Awaited<ReturnType<typeof updateTgBotChannel>>
>;
export type UpdateMaxBotChannelResult = NonNullable<
  Awaited<ReturnType<typeof updateMaxBotChannel>>
>;
export type UpdateNumberResult = NonNullable<
  Awaited<ReturnType<typeof updateNumber>>
>;
export type InitSMSResult = NonNullable<Awaited<ReturnType<typeof initSMS>>>;
export type VerifySMSResult = NonNullable<
  Awaited<ReturnType<typeof verifySMS>>
>;

export const getCreateTgPersonalChannelResponseMock = (
  overrideResponse: Partial<ChannelDetails> = {}
): ChannelDetails => ({
  id: faker.string.uuid(),
  owner_id: faker.string.uuid(),
  protocol: faker.helpers.arrayElement(Object.values(Protocol)),
  status: faker.helpers.arrayElement(Object.values(ChannelStatus)),
  is_active: faker.datatype.boolean(),
  qr_url: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  qr_expires: faker.helpers.arrayElement([
    `${faker.date.past().toISOString().split('.')[0]}Z`,
    undefined,
  ]),
  name: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  phone_number: faker.string.alpha({ length: { min: 10, max: 20 } }),
  company_id: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getCreateTgBotChannelResponseMock = (
  overrideResponse: Partial<ChannelDetails> = {}
): ChannelDetails => ({
  id: faker.string.uuid(),
  owner_id: faker.string.uuid(),
  protocol: faker.helpers.arrayElement(Object.values(Protocol)),
  status: faker.helpers.arrayElement(Object.values(ChannelStatus)),
  is_active: faker.datatype.boolean(),
  qr_url: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  qr_expires: faker.helpers.arrayElement([
    `${faker.date.past().toISOString().split('.')[0]}Z`,
    undefined,
  ]),
  name: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  phone_number: faker.string.alpha({ length: { min: 10, max: 20 } }),
  company_id: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getCreateWhatsappGrayChannelResponseMock = (
  overrideResponse: Partial<ChannelDetails> = {}
): ChannelDetails => ({
  id: faker.string.uuid(),
  owner_id: faker.string.uuid(),
  protocol: faker.helpers.arrayElement(Object.values(Protocol)),
  status: faker.helpers.arrayElement(Object.values(ChannelStatus)),
  is_active: faker.datatype.boolean(),
  qr_url: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  qr_expires: faker.helpers.arrayElement([
    `${faker.date.past().toISOString().split('.')[0]}Z`,
    undefined,
  ]),
  name: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  phone_number: faker.string.alpha({ length: { min: 10, max: 20 } }),
  company_id: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getInitiateCreateChannelResponseMock = (
  overrideResponse: Partial<ChannelDetails> = {}
): ChannelDetails => ({
  id: faker.string.uuid(),
  owner_id: faker.string.uuid(),
  protocol: faker.helpers.arrayElement(Object.values(Protocol)),
  status: faker.helpers.arrayElement(Object.values(ChannelStatus)),
  is_active: faker.datatype.boolean(),
  qr_url: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  qr_expires: faker.helpers.arrayElement([
    `${faker.date.past().toISOString().split('.')[0]}Z`,
    undefined,
  ]),
  name: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  phone_number: faker.string.alpha({ length: { min: 10, max: 20 } }),
  company_id: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getGetChannelsResponseMock = (
  overrideResponse: Partial<ChannelListPagination> = {}
): ChannelListPagination => ({
  data: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1
    ).map(() => ({
      id: faker.string.uuid(),
      owner_id: faker.string.uuid(),
      protocol: faker.helpers.arrayElement(Object.values(Protocol)),
      status: faker.helpers.arrayElement(Object.values(ChannelStatus)),
      is_active: faker.datatype.boolean(),
      name: faker.helpers.arrayElement([
        faker.string.alpha({ length: { min: 10, max: 20 } }),
        undefined,
      ]),
      phone_number: faker.string.alpha({ length: { min: 10, max: 20 } }),
      company_id: faker.helpers.arrayElement([
        faker.string.alpha({ length: { min: 10, max: 20 } }),
        undefined,
      ]),
    })),
    undefined,
  ]),
  pagination: faker.helpers.arrayElement([
    {
      total: faker.number.int({ min: undefined, max: undefined }),
      page: faker.number.int({ min: undefined, max: undefined }),
      limit: faker.number.int({ min: undefined, max: undefined }),
    },
    undefined,
  ]),
  ...overrideResponse,
});

export const getCreateChannelResponseMock = (
  overrideResponse: Partial<ChannelDetails> = {}
): ChannelDetails => ({
  id: faker.string.uuid(),
  owner_id: faker.string.uuid(),
  protocol: faker.helpers.arrayElement(Object.values(Protocol)),
  status: faker.helpers.arrayElement(Object.values(ChannelStatus)),
  is_active: faker.datatype.boolean(),
  qr_url: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  qr_expires: faker.helpers.arrayElement([
    `${faker.date.past().toISOString().split('.')[0]}Z`,
    undefined,
  ]),
  name: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  phone_number: faker.string.alpha({ length: { min: 10, max: 20 } }),
  company_id: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getGetChannelByIdResponseMock = (
  overrideResponse: Partial<ChannelDetails> = {}
): ChannelDetails => ({
  id: faker.string.uuid(),
  owner_id: faker.string.uuid(),
  protocol: faker.helpers.arrayElement(Object.values(Protocol)),
  status: faker.helpers.arrayElement(Object.values(ChannelStatus)),
  is_active: faker.datatype.boolean(),
  qr_url: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  qr_expires: faker.helpers.arrayElement([
    `${faker.date.past().toISOString().split('.')[0]}Z`,
    undefined,
  ]),
  name: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  phone_number: faker.string.alpha({ length: { min: 10, max: 20 } }),
  company_id: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getUpdateChannelByIdResponseMock = (
  overrideResponse: Partial<ChannelDetails> = {}
): ChannelDetails => ({
  id: faker.string.uuid(),
  owner_id: faker.string.uuid(),
  protocol: faker.helpers.arrayElement(Object.values(Protocol)),
  status: faker.helpers.arrayElement(Object.values(ChannelStatus)),
  is_active: faker.datatype.boolean(),
  qr_url: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  qr_expires: faker.helpers.arrayElement([
    `${faker.date.past().toISOString().split('.')[0]}Z`,
    undefined,
  ]),
  name: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  phone_number: faker.string.alpha({ length: { min: 10, max: 20 } }),
  company_id: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getGetChannelLogsByChannelIdResponseMock = (): Log[] =>
  Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1
  ).map(() => ({
    ...{ id: faker.string.uuid() },
    ...{
      channel_id: faker.string.uuid(),
      severity: faker.string.alpha({ length: { min: 10, max: 20 } }),
      event_time: faker.string.alpha({ length: { min: 10, max: 20 } }),
      content: faker.string.alpha({ length: { min: 10, max: 20 } }),
      type: faker.string.alpha({ length: { min: 10, max: 20 } }),
    },
  }));

export const getQrLoginChannelResponseMock = (
  overrideResponse: Partial<ChannelDetails> = {}
): ChannelDetails => ({
  id: faker.string.uuid(),
  owner_id: faker.string.uuid(),
  protocol: faker.helpers.arrayElement(Object.values(Protocol)),
  status: faker.helpers.arrayElement(Object.values(ChannelStatus)),
  is_active: faker.datatype.boolean(),
  qr_url: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  qr_expires: faker.helpers.arrayElement([
    `${faker.date.past().toISOString().split('.')[0]}Z`,
    undefined,
  ]),
  name: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  phone_number: faker.string.alpha({ length: { min: 10, max: 20 } }),
  company_id: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getUpdateTgBotChannelResponseMock = (
  overrideResponse: Partial<ChannelDetails> = {}
): ChannelDetails => ({
  id: faker.string.uuid(),
  owner_id: faker.string.uuid(),
  protocol: faker.helpers.arrayElement(Object.values(Protocol)),
  status: faker.helpers.arrayElement(Object.values(ChannelStatus)),
  is_active: faker.datatype.boolean(),
  qr_url: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  qr_expires: faker.helpers.arrayElement([
    `${faker.date.past().toISOString().split('.')[0]}Z`,
    undefined,
  ]),
  name: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  phone_number: faker.string.alpha({ length: { min: 10, max: 20 } }),
  company_id: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getUpdateMaxBotChannelResponseMock = (
  overrideResponse: Partial<ChannelDetails> = {}
): ChannelDetails => ({
  id: faker.string.uuid(),
  owner_id: faker.string.uuid(),
  protocol: faker.helpers.arrayElement(Object.values(Protocol)),
  status: faker.helpers.arrayElement(Object.values(ChannelStatus)),
  is_active: faker.datatype.boolean(),
  qr_url: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  qr_expires: faker.helpers.arrayElement([
    `${faker.date.past().toISOString().split('.')[0]}Z`,
    undefined,
  ]),
  name: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  phone_number: faker.string.alpha({ length: { min: 10, max: 20 } }),
  company_id: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getUpdateNumberResponseMock = (
  overrideResponse: Partial<ChannelDetails> = {}
): ChannelDetails => ({
  id: faker.string.uuid(),
  owner_id: faker.string.uuid(),
  protocol: faker.helpers.arrayElement(Object.values(Protocol)),
  status: faker.helpers.arrayElement(Object.values(ChannelStatus)),
  is_active: faker.datatype.boolean(),
  qr_url: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  qr_expires: faker.helpers.arrayElement([
    `${faker.date.past().toISOString().split('.')[0]}Z`,
    undefined,
  ]),
  name: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  phone_number: faker.string.alpha({ length: { min: 10, max: 20 } }),
  company_id: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getCreateTgPersonalChannelMockHandler = (
  overrideResponse?:
    | ChannelDetails
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0]
      ) => Promise<ChannelDetails> | ChannelDetails),
  options?: RequestHandlerOptions
) => {
  return http.post(
    '*/api/v1/channels/tg_personal',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getCreateTgPersonalChannelResponseMock()
        ),
        { status: 201, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getCreateTgBotChannelMockHandler = (
  overrideResponse?:
    | ChannelDetails
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0]
      ) => Promise<ChannelDetails> | ChannelDetails),
  options?: RequestHandlerOptions
) => {
  return http.post(
    '*/api/v1/channels/tg_bot',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getCreateTgBotChannelResponseMock()
        ),
        { status: 201, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getCreateWhatsappGrayChannelMockHandler = (
  overrideResponse?:
    | ChannelDetails
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0]
      ) => Promise<ChannelDetails> | ChannelDetails),
  options?: RequestHandlerOptions
) => {
  return http.post(
    '*/api/v1/channels/whatsapp',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getCreateWhatsappGrayChannelResponseMock()
        ),
        { status: 201, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getInitiateCreateChannelMockHandler = (
  overrideResponse?:
    | ChannelDetails
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0]
      ) => Promise<ChannelDetails> | ChannelDetails),
  options?: RequestHandlerOptions
) => {
  return http.post(
    '*/api/v1/channel/create/:channelType',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getInitiateCreateChannelResponseMock()
        ),
        { status: 201, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getGetChannelsMockHandler = (
  overrideResponse?:
    | ChannelListPagination
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<ChannelListPagination> | ChannelListPagination),
  options?: RequestHandlerOptions
) => {
  return http.get(
    '*/api/v1/channels',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetChannelsResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getCreateChannelMockHandler = (
  overrideResponse?:
    | ChannelDetails
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0]
      ) => Promise<ChannelDetails> | ChannelDetails),
  options?: RequestHandlerOptions
) => {
  return http.post(
    '*/api/v1/channels',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getCreateChannelResponseMock()
        ),
        { status: 201, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getGetChannelByIdMockHandler = (
  overrideResponse?:
    | ChannelDetails
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<ChannelDetails> | ChannelDetails),
  options?: RequestHandlerOptions
) => {
  return http.get(
    '*/api/v1/channels/:channelId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetChannelByIdResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getUpdateChannelByIdMockHandler = (
  overrideResponse?:
    | ChannelDetails
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0]
      ) => Promise<ChannelDetails> | ChannelDetails),
  options?: RequestHandlerOptions
) => {
  return http.put(
    '*/api/v1/channels/:channelId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getUpdateChannelByIdResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getDeleteChannelByIdMockHandler = (
  overrideResponse?:
    | void
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0]
      ) => Promise<void> | void),
  options?: RequestHandlerOptions
) => {
  return http.delete(
    '*/api/v1/channels/:channelId',
    async (info) => {
      await delay(1000);
      if (typeof overrideResponse === 'function') {
        await overrideResponse(info);
      }
      return new HttpResponse(null, { status: 204 });
    },
    options
  );
};

export const getGetChannelLogsByChannelIdMockHandler = (
  overrideResponse?:
    | Log[]
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<Log[]> | Log[]),
  options?: RequestHandlerOptions
) => {
  return http.get(
    '*/api/v1/channels/:channelId/logs',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetChannelLogsByChannelIdResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getQrLoginChannelMockHandler = (
  overrideResponse?:
    | ChannelDetails
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0]
      ) => Promise<ChannelDetails> | ChannelDetails),
  options?: RequestHandlerOptions
) => {
  return http.post(
    '*/api/v1/channels/:channelId/qr_login',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getQrLoginChannelResponseMock()
        ),
        { status: 201, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getSendTgPersonalPasswordMockHandler = (
  overrideResponse?:
    | void
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0]
      ) => Promise<void> | void),
  options?: RequestHandlerOptions
) => {
  return http.post(
    '*/api/v1/channels/:channelId/tg_personal/password',
    async (info) => {
      await delay(1000);
      if (typeof overrideResponse === 'function') {
        await overrideResponse(info);
      }
      return new HttpResponse(null, { status: 200 });
    },
    options
  );
};

export const getPrivateSendTgPersonalPasswordMockHandler = (
  overrideResponse?:
    | void
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0]
      ) => Promise<void> | void),
  options?: RequestHandlerOptions
) => {
  return http.post(
    '*/api/v1/private/channels/:channelId/tg_personal/password',
    async (info) => {
      await delay(1000);
      if (typeof overrideResponse === 'function') {
        await overrideResponse(info);
      }
      return new HttpResponse(null, { status: 200 });
    },
    options
  );
};

export const getUpdateTgBotChannelMockHandler = (
  overrideResponse?:
    | ChannelDetails
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0]
      ) => Promise<ChannelDetails> | ChannelDetails),
  options?: RequestHandlerOptions
) => {
  return http.put(
    '*/api/v1/channels/tg_bot/:channelId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getUpdateTgBotChannelResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getUpdateMaxBotChannelMockHandler = (
  overrideResponse?:
    | ChannelDetails
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0]
      ) => Promise<ChannelDetails> | ChannelDetails),
  options?: RequestHandlerOptions
) => {
  return http.put(
    '*/api/v1/channels/max_bot/:channelId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getUpdateMaxBotChannelResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getUpdateNumberMockHandler = (
  overrideResponse?:
    | ChannelDetails
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0]
      ) => Promise<ChannelDetails> | ChannelDetails),
  options?: RequestHandlerOptions
) => {
  return http.post(
    '*/api/v1/channels/:channelId/update_number',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getUpdateNumberResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getInitSMSMockHandler = (
  overrideResponse?:
    | void
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0]
      ) => Promise<void> | void),
  options?: RequestHandlerOptions
) => {
  return http.post(
    '*/api/v1/channels/:channelId/init-sms',
    async (info) => {
      await delay(1000);
      if (typeof overrideResponse === 'function') {
        await overrideResponse(info);
      }
      return new HttpResponse(null, { status: 201 });
    },
    options
  );
};

export const getVerifySMSMockHandler = (
  overrideResponse?:
    | void
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0]
      ) => Promise<void> | void),
  options?: RequestHandlerOptions
) => {
  return http.post(
    '*/api/v1/channels/:channelId/verify-sms',
    async (info) => {
      await delay(1000);
      if (typeof overrideResponse === 'function') {
        await overrideResponse(info);
      }
      return new HttpResponse(null, { status: 200 });
    },
    options
  );
};
export const getChannelAPIMock = () => [
  getCreateTgPersonalChannelMockHandler(),
  getCreateTgBotChannelMockHandler(),
  getCreateWhatsappGrayChannelMockHandler(),
  getInitiateCreateChannelMockHandler(),
  getGetChannelsMockHandler(),
  getCreateChannelMockHandler(),
  getGetChannelByIdMockHandler(),
  getUpdateChannelByIdMockHandler(),
  getDeleteChannelByIdMockHandler(),
  getGetChannelLogsByChannelIdMockHandler(),
  getQrLoginChannelMockHandler(),
  getSendTgPersonalPasswordMockHandler(),
  getPrivateSendTgPersonalPasswordMockHandler(),
  getUpdateTgBotChannelMockHandler(),
  getUpdateMaxBotChannelMockHandler(),
  getUpdateNumberMockHandler(),
  getInitSMSMockHandler(),
  getVerifySMSMockHandler(),
];
